// extracted by mini-css-extract-plugin
module.exports = {"helpButton":"_1pp7Xi","note":"_1GxqdO"};